import React, { useState, useEffect } from "react"

const uniq = (value, index, self) => self.indexOf(value) === index;
export const TimeSelect = ({ day, dates, value, onChange }) => {
    const [options, setOptions] = useState(null);

    useEffect(() => {
        if (day) {
            const { closes, opens } = (dates.filter(item => item).filter(uniq).find(({ date }) =>
                date.getDate() === day.getDate() &&
                date.getMonth() === day.getMonth() &&
                date.getFullYear() === day.getFullYear()));
            const [startH, startM] = opens.split(':');
            const start = Number(startH) * 60 + Number(startM);
            const [endH, endM] = closes.split(':');
            const end = Number(endH) * 60 + Number(endM);
            const arr = [];
            for (let i = start; i < end; i += 30) {
                arr.push(`${(Math.floor(i / 60)).toString().padStart(2, '0')}:${(i % 60).toString().padStart(2, '0')}`);
            }
            setOptions([].concat(arr.map(time => <option key={`TimeSelect_${time}`} value={time}>{time}</option>)));

        }
    }, [day]);
    return <select disabled={!day} className="custom-select" value={value} defaultValue='Ønsket tid' onChange={onChange}>
        <option key='TimeSelect_default' style={{ display: 'none' }}>Ønsket tid</option>
        {options}
    </select>;
}